import { render, staticRenderFns } from "./ViewContainerRichTextKlv3.vue?vue&type=template&id=43c1041b&scoped=true"
import script from "./ViewContainerRichTextKlv3.vue?vue&type=script&lang=js"
export * from "./ViewContainerRichTextKlv3.vue?vue&type=script&lang=js"
import style0 from "./ViewContainerRichTextKlv3.vue?vue&type=style&index=0&id=43c1041b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c1041b",
  null
  
)

export default component.exports